// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'be8d446e';
